module.exports = __webpack_public_path__ + "media/AUDIO 06.2cc24235.mp3";